// Libs
import React from 'react';
import { Form, Modal } from 'react-bootstrap';
import Select from 'react-select';
import ExpandingTextArea from 'react-expanding-textarea';
import moment from 'moment';

// Services & Helpers
import LanguageService from 'services/LanguageService';
import CourseService from 'services/CourseService';
import BookingService from 'services/BookingService';
import BootboxHelper from 'helpers/BootboxHelper';

// Components
import Loader from 'components/common/Loader';
import DatePicker from 'components/common/DatePicker';

//-------------------------------------------------------------------------------------------------------------------

class SubmitEnquiryModal extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            isOpen: false,
            enquiry: {}
        };
    }

    show(opts) {
        return new Promise((resolve, reject) => {
            this.opts = opts;
            this.setState({
                isOpen: true,
                isLoading: true,
                enquiry: {
                    enquiryDate: moment().format('YYYY-MM-DD'),
                    enquirySource: 'OnlineForm'
                }
            }, () => {
                this.load();
            });
        });
    }

    async load() {
        const languagesReq = LanguageService.list();
        const coursesReq = CourseService.list();
        this.setState({
            courses: await coursesReq,
            languages: await languagesReq,
            isLoading: false
        });
    }

    close() {
        this.setState({ isOpen: false });
    }

    updateFields(values) {
        const enquiry = { ...this.state.enquiry };
        for (var field in values) {
            let value = values[field];
            enquiry[field] = value;
        }
        this.setState({ enquiry });
    }

    async save() {
        const { enquiry } = this.state;
        return new Promise(async (resolve) => {
            this.setState({ isLoading: true });
            try {
                const id = await BookingService.submitEnquiry(enquiry);
                if (!enquiry.id) {
                    this.updateFields({ id });
                }
                this.setState({
                    isLoading: false
                }, () => {
                    BootboxHelper.alert('Thank you, your enquiry has been submitted.');
                    resolve(id);
                });
            } catch (error) {
                BootboxHelper.alert(error);
                this.setState({ isLoading: false });
            }
        });
    }

    async saveAndClose() {
        await this.save();
        this.close();
        this.resolve();
    }

    render() {
        const { isOpen } = this.state;
        if (!isOpen) {
            return null;
        }

        return (
            <Modal show className="submit-enquiry-modal">
                <div className="modal-header">
                    <h5>Submit Enquiry</h5>
                </div>
                <form onSubmit={e => { e.preventDefault(); this.saveAndClose() }}>
                    <Modal.Body>
                        {this.renderInner()}
                    </Modal.Body>
                    <Modal.Footer>
                        <button type="button" className="btn btn-secondary me-auto" onClick={() => this.close()}>
                            Cancel
                        </button>
                        <button type="submit" className="btn btn-primary ms-auto">
                            Submit Enquiry
                        </button>
                    </Modal.Footer>
                </form>
            </Modal>
        );
    }
    
    renderInner() {
        const {
            isLoading,
            enquiry,
            languages,
            courses
        } = this.state;

        if (isLoading) {
            return (<Loader />);
        }

        return (<>

            <Form.Group className="mb-3">
                <Form.Label>Course</Form.Label>
                <Select
                    className="react-select-container"
                    classNamePrefix="react-select"
                    value={enquiry.courseID ? courses.find(c => c.id == enquiry.courseID) : null}
                    options={enquiry.id ? courses : courses.filter(c => !c.isDeprecated)}
                    getOptionValue={c => c.id}
                    getOptionLabel={c => `${c.name} (${c.tier})`}
                    onChange={v => this.updateFields({ courseID: v.id })}
                />
            </Form.Group>
            
            <Form.Group className="with-jam mb-3">
                <div className="form-check">
                    <label>
                        <input
                            type="checkbox"
                            checked={enquiry.isWithJAM}
                            onChange={e => this.updateFields({ isWithJAM: e.target.checked })}
                        />{' '}
                        With AWS Jam
                    </label>
                </div>
            </Form.Group>

            <Form.Group className="mb-3">
                <Form.Label>Language</Form.Label>
                <Select
                    className="react-select-container"
                    classNamePrefix="react-select"
                    value={enquiry.languageID ? languages.find(l => l.id == enquiry.languageID) : null}
                    options={languages}
                    getOptionValue={l => l.id}
                    getOptionLabel={l => l.name}
                    onChange={v => this.updateFields({ languageID: v.id })}
                />
            </Form.Group>

            <Form.Group className="mb-3">
                <Form.Label>Start Date</Form.Label>
                <DatePicker
                    className="form-control"
                    selected={enquiry.startDate ? new Date(enquiry.startDate) : null}
                    onChange={value => this.updateFields({ startDate: value })}
                />
            </Form.Group>

            <Form.Group className="mb-3">
                <Form.Label>Details of request</Form.Label>
                <ExpandingTextArea
                    rows={3}
                    className="form-control"
                    value={enquiry.enquiryDetails || ''}
                    onChange={e => this.updateFields({ enquiryDetails: e.target.value })}
                />
            </Form.Group>

        </>);
    }
    
}

export default SubmitEnquiryModal;